import React from 'react';
import ProductCard from "./ProductCard";

const ProductCardSlider = ({data, bgPagination}) => {
    return (
        <div className="product-card  position-relative">
            <div className="swiper product-card-swiper  position-relative">
                <div className={"swiper-scrollbar-card position-absolute bgPagination-"+(bgPagination)}>

                </div>
                <div className="swiper-wrapper">
                    {data && data.map((product) => (
                        <div className="swiper-slide" key={product.id}>
                            <ProductCard product={product}/>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProductCardSlider;
